import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { Body, BodyContent, BodyHeading } from "@thrivetribe/mvf.ui.organisms.body";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { RecipeListing } from "ui/molecules/RecipeListing";
import "./RecipesPage.scss";

export const RecipesPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Body className="recipes">
      <>
        <Helmet>
          <title>Recipes - MAN v FAT</title>
        </Helmet>
        <BodyHeading slim>
          <Button variant="text" onClick={() => navigate(-1)}>
            <ButtonArrow />
            Back
          </Button>
          <h1>Recipes</h1>
        </BodyHeading>

        <BodyContent>
          <RecipeListing />
        </BodyContent>
      </>
    </Body>
  );
};
